import './testimonials.scss';
import { register } from 'swiper/element/bundle';
import type { SwiperWebComponent } from '../../../assets/src/ts/types/swiper-element';

register();

// Slider des témoignages : effet fade en desktop, boutons custom et
// barres de progression d'autoplay (init="false" dans le twig).
const containers = document.querySelectorAll('swiper-container[data-testimonials]') as NodeListOf<SwiperWebComponent>;

containers?.forEach(container => {
    if (container.dataset.testimonialsInit) return;
    container.dataset.testimonialsInit = 'true';

    const customButtons = (container: SwiperWebComponent) => {
        container.querySelectorAll('[data-swiper-prev]')?.forEach(btn => btn.addEventListener('click', () => container.swiper.slidePrev()));
        container.querySelectorAll('[data-swiper-next]')?.forEach(btn => btn.addEventListener('click', () => container.swiper.slideNext()));
    };

    const setupAutoplayProgress = (container: SwiperWebComponent) => {
        const bars = container.querySelectorAll('.autoplay-progress-bar') as NodeListOf<HTMLElement>;

        const animateProgress = (bars: NodeListOf<HTMLElement>) => {
            bars?.forEach((bar) => {
                void bar.offsetWidth;

                bar.classList.add('running');
            });
        };

        const resetProgress = (bars: NodeListOf<HTMLElement>) => {
            bars?.forEach((bar) => {
                bar.classList.remove('running');
            });
        };

        const onSlideChange = () => {
            resetProgress(bars);

            requestAnimationFrame(() => {
                animateProgress(bars);
            });
        };

        setTimeout(() => {
            onSlideChange();
            container.swiper.on('slideChange', onSlideChange);
        }, 400);
    };

    const styleInMobile = (container: SwiperWebComponent) => {
        const isMobile = () => window.innerWidth < 900;

        const swiperParams = {
            effect: !isMobile() ? 'fade' : 'slide',
        };
        Object.assign(container, swiperParams);
    };

    styleInMobile(container);
    customButtons(container);
    setupAutoplayProgress(container);
    container.initialize();
});
